<template>
  <button class="btn btn-primary" type="button" @click="openModal">
    Agregar Ambiente
  </button>

  <div
    class="modal fade"
    ref="modalPlace"
    id="exampleModalCenter"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalCenter"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered" role="document">
      <vee-form
        :validation-schema="placeSchema"
        @submit="registerPlace"
        @invalid-submit="onInvalid"
      >
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Agregar ambiente</h5>
            <button
              class="btn-close"
              type="button"
              @click="closeModal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col">
                <div class="mb-3">
                  <label>Nombre del ambiente</label>
                  <vee-field
                    class="form-control"
                    name="description"
                    type="text"
                    placeholder="Nombre del ambiente"
                  />
                  <ErrorMessage class="text-danger" name="description" />
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-sm-4">
                <div class="mb-3">
                  <label>Capacidad</label>
                  <vee-field
                    class="form-control"
                    name="capacity"
                    type="number"
                    placeholder="Capacidad"
                  />
                  <ErrorMessage class="text-danger" name="capacity" />
                </div>
              </div>
              <div class="col-sm-8">
                <div class="mb-3">
                  <label>Referencia</label>
                  <vee-field
                    class="form-control"
                    name="reference"
                    as="textarea"
                    placeholder="Referencia"
                  />
                  <ErrorMessage class="text-danger" name="reference" />
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col">
                <label>Selecciona la ubicación</label>
                <div
                  id="map-container"
                  ref="mapContainer"
                  style="height: 350px; width: 100%; margin-top: 10px"
                >
                  <l-map
                    v-if="showMap"
                    ref="map"
                    :zoom="zoom"
                    :center="center"
                    @update:center="updateCenter"
                    @ready="onMapReady"
                    style="height: 100%; width: 100%"
                  >
                    <l-tile-layer
                      url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                      :max-zoom="19"
                      :min-zoom="1"
                    />
                    <l-marker
                      :lat-lng="markerLatLng"
                      draggable
                      @moveend="updateMarker"
                    />
                  </l-map>
                </div>
              </div>
            </div>
            <vee-field name="latitude" type="hidden" value="" />
            <vee-field name="longitude" type="hidden" value="" />
          </div>
          <div class="modal-footer">
            <button class="btn btn-secondary" type="button" @click="closeModal">
              Cancelar
            </button>
            <button class="btn btn-primary" type="submit">Registrar</button>
          </div>
        </div>
      </vee-form>
    </div>
  </div>
</template>

<script>
import { Modal } from "bootstrap";
import { useForm } from "vee-validate";
import { LMap, LTileLayer, LMarker } from "@vue-leaflet/vue-leaflet";
import "leaflet/dist/leaflet.css";

import L from "leaflet";
import { latLng } from "leaflet";
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl:
    "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon-2x.png",
  iconUrl:
    "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png",
  shadowUrl:
    "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png",
});

export default {
  name: "ModalCreate",
  emits: ["reload-list-place"],
  components: {
    LMap,
    LTileLayer,
    LMarker,
  },
  setup() {
    const { setFieldValue } = useForm();
    return { setFieldValue };
  },
  data() {
    return {
      placeSchema: {
        description: "required",
        capacity: "required|min:2",
        reference: "required",
      },
      placeModal: null,
      showMap: false,
      zoom: 15,
      center: [-16.506363, -68.127774], // ministerio de educacion
      markerLatLng: [-16.506363, -68.127774], // coordenadas iniciales
      //attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      mapInitialized: false,
    };
  },
  mounted() {
    this.placeModal = new Modal(this.$refs.modalPlace);

    this.$refs.modalPlace.addEventListener("shown.bs.modal", this.onModalShown);
    this.$refs.modalPlace.addEventListener(
      "hidden.bs.modal",
      this.onModalHidden
    );
  },
  beforeUnmount() {
    if (this.$refs.modalPlace) {
      this.$refs.modalPlace.removeEventListener(
        "shown.bs.modal",
        this.onModalShown
      );
      this.$refs.modalPlace.removeEventListener(
        "hidden.bs.modal",
        this.onModalHidden
      );
    }
  },
  methods: {
    openModal() {
      this.placeModal.show();
    },

    closeModal() {
      this.placeModal.hide();
    },

    onModalShown() {
      setTimeout(() => {
        this.showMap = true;
        this.$nextTick(() => {
          setTimeout(() => {
            this.initializeMap();
            this.setFieldValue("latitude", this.markerLatLng[0]);
            this.setFieldValue("longitude", this.markerLatLng[1]);
          }, 100);
        });
      }, 150);
    },

    onModalHidden() {
      this.showMap = false;
      this.resetModal();
    },

    resetModal() {
      this.zoom = 15;
      this.center = [-16.506363, -68.127774];
      this.markerLatLng = [-16.506363, -68.127774];
      this.mapInitialized = false;

      this.$nextTick(() => {
        this.setFieldValue("description", "");
        this.setFieldValue("capacity", "");
        this.setFieldValue("reference", "");
        this.setFieldValue("latitude", "");
        this.setFieldValue("longitude", "");
      });
    },

    initializeMap() {
      if (
        this.$refs.map &&
        this.$refs.map.leafletObject &&
        !this.mapInitialized
      ) {
        try {
          const map = this.$refs.map.leafletObject;

          map.invalidateSize(true);

          map.setView(this.center, this.zoom);

          setTimeout(() => {
            map.invalidateSize(true);
            map.setView(this.center, this.zoom);
          }, 50);

          this.mapInitialized = true;
        } catch (error) {
          console.error("Error inicializando el mapa:", error);
        }
      }
    },

    onMapReady() {
      this.$nextTick(() => {
        setTimeout(() => {
          this.initializeMap();
        }, 100);
      });
    },

    updateMarker(event) {
      const { lat, lng } = event.target.getLatLng();
      if (isFinite(lat) && isFinite(lng)) {
        this.markerLatLng = [lat, lng];
        this.setFieldValue("latitude", lat);
        this.setFieldValue("longitude", lng);
      }
    },

    updateCenter(center) {
      if (
        Array.isArray(center) &&
        center.length === 2 &&
        isFinite(center[0]) &&
        isFinite(center[1])
      ) {
        this.center = center;
      }
    },

    toPascalCase(str) {
      return str.replace(
        /(\w)(\w*)/g,
        (_, first, rest) => first.toUpperCase() + rest.toLowerCase()
      );
    },

    registerPlace(values, { resetForm }) {
      const userId = parseInt(localStorage.getItem("userId"));
      this.$swal
        .fire({
          title: "¿Está seguro?",
          text: "Se registrará el nuevo ambiente.",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Registrar",
          cancelButtonText: "Cancelar",
        })
        .then((result) => {
          if (!this.markerLatLng || this.markerLatLng.length !== 2) {
            this.$swal.fire({
              title: "Error de ubicación",
              text: "Por favor, selecciona una ubicación en el mapa.",
              icon: "error",
            });
            return;
          }
          const [lat, lng] = this.markerLatLng;

          if (result.isConfirmed) {
            const payload = {
              reference: this.toPascalCase(values.reference),
              description: this.toPascalCase(values.description),
              latitude: lat.toString(),
              longitude: lng.toString(),
              capacity: Number(values.capacity),
              user_id: userId,
            };

            this.$axios
              .post("/place", payload, {
                headers: {
                  "Content-Type": "application/json",
                },
              })
              .then((response) => {
                resetForm();
                this.mapInitialized = false;
                this.$swal
                  .fire({
                    title: "Registro Exitoso",
                    text: "El ambiente se registró de manera exitosa",
                    icon: "success",
                  })
                  .then((result) => {
                    if (result.isConfirmed) {
                      this.$emit("reload-list-place");
                      this.closeModal();
                    }
                  });
              })
              .catch((error) => {
                console.error(error);
                this.$swal.fire({
                  title: "Registro fallido",
                  text: "El ambiente no se registró",
                  icon: "error",
                });
              });
          }
        });
    },

    onInvalid({ errors }) {
      this.$swal.fire({
        title: "Formulario incompleto",
        text: "Por favor completa todos los campos correctamente.",
        icon: "warning",
      });
    },
  },
};
</script>

<style scoped>
#map-container {
  border: 1px solid #ddd;
  border-radius: 4px;
  background-color: #f8f9fa;
  position: relative;
  overflow: hidden;
}

.modal-dialog {
  margin: 1.75rem auto;
}

.modal-body .leaflet-container {
  z-index: 1 !important;
}

.leaflet-container {
  height: 100% !important;
  width: 100% !important;
  position: relative;
}

.leaflet-container.leaflet-touch-zoom {
  -ms-touch-action: pan-x pan-y;
  touch-action: pan-x pan-y;
}

.leaflet-map-pane {
  position: absolute;
}

.leaflet-tile-pane {
  position: absolute;
}
</style>
